'use client'

import advisorImage from '@/assets/images/advisor.png'
import isoImage from '@/assets/images/iso.png'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'

export function Legal({ lastModified }: { lastModified: string }) {
  const t = useTranslations('Footer')

  return (
    <div className="w-full max-w-[550px] space-y-6">
      <p className="text-body-3">{t('updatedAt', { date: lastModified })}</p>
      <div className="text-caption space-y-4 leading-6">
        <p>{t('legal.footnote1')}</p>
        <p>{t('legal.footnote2')}</p>
      </div>

      <div className="space-y-4">
        <div className="flex gap-10">
          <Image
            src={advisorImage}
            alt="Advisor"
            width={60}
            height={60}
            className="brightness-0 invert"
          />
          <Link
            href="/docs/iso.pdf"
            target="_blank"
            referrerPolicy="no-referrer"
          >
            <Image src={isoImage} alt="ISO" width={60} height={60} />
          </Link>
        </div>
        <p className="text-caption uppercase">{t('legal.centralBank')}</p>
      </div>
    </div>
  )
}
